import { AxiosResponse } from 'axios';
import { api, buildPayload, CONTENT_TYPE } from './axios';
import { MailMePayload, SessionIdPayload } from '../actions/auth/payloads';
import {Session} from "../../services/endpoints";
import { APIErrorInterface } from '../types';

export interface ApiLoginPayload {
    login: string;
    password: string;
    enable_csrf_protection?: number;
    skipCustomerRealmSignIn?: boolean;
}

export interface PostLoginResult {
    success: boolean;
    sessionResult?: SessionIdPayload;
    apiError?: APIErrorInterface;
}

export interface PostPasswordRecoveryResult {
    success: boolean;
    successResult?: {
        success: boolean
    };
    apiError?: APIErrorInterface;
}

export interface ApiChangePasswordPayload {
    login: string;
    password: string;
    new_password: string;
    one_time_password?: string;
    onSuccess?: () => void
}

export function* postLogin (
    payload: ApiLoginPayload,
    baseUrl: string
) {
    const data = buildPayload(payload);
    const options = {
        headers: {
            'Content-Type': CONTENT_TYPE,
        },
        withCredentials: true,
        baseURL: baseUrl,
    };

    try {
        const result: AxiosResponse<SessionIdPayload> = yield api.post(Session.Login, data, options);
        
        return {
            success: true,
            sessionResult: result.data
        } as PostLoginResult;
    } catch (err) {
        return {
            success: false,
            // @ts-ignore
            apiError: err?.response?.data ? err.response.data as APIErrorInterface : undefined
        } as PostLoginResult;
    }
}

export async function postChangePassword(
    payload: ApiChangePasswordPayload,
): Promise<AxiosResponse> {
    const data = buildPayload(payload);
    const options = {
        headers: {
            'Content-Type': CONTENT_TYPE,
        },
    };

    return api.post(Session.ChangePassword, data, options);
}

export function* postPasswordRecovery (
    payload: MailMePayload,
    baseUrl: string
) {
    const data = buildPayload(payload);
    const options = {
        headers: {
            'Content-Type': CONTENT_TYPE,
        },
        baseURL: baseUrl,
    };

    try {
        const result: AxiosResponse<{
            success: boolean
        }> = yield api.post(Session.ResetPassword, data, options);
        
        return {
            success: true,
            sessionResult: result.data
        } as PostPasswordRecoveryResult;
    } catch (err) {
        return {
            success: false,
            // @ts-ignore
            apiError: err?.response?.data ? err.response.data as APIErrorInterface : undefined
        } as PostPasswordRecoveryResult;
    }
}

export async function postPing(session_id: string, csrf_token: string) {
    const data = buildPayload({ session_id: session_id, csrf_token: csrf_token });
    const options = {
        headers: {
            'Content-Type': CONTENT_TYPE,
        },
    };

    return api.post(Session.Ping, data, options);
}
